import { winloc } from 'app-config/config.js'

const PRODUCTION_HIDDEN_ROUTES = Object.freeze(['asset-register', 'property-risk-register', 'rfid-sessions'])

const normaliseRoute = route =>
    String(route || '')
        .replace(/^\/+/, '')
        .split('/')[0]

export const isFarmdeckHost = (hostname = winloc.hostname) => String(hostname || '').includes('farmdeck.com')

export const isFeatureRouteAvailable = (route, farmdeckHost = isFarmdeckHost()) => !farmdeckHost || !PRODUCTION_HIDDEN_ROUTES.includes(normaliseRoute(route))
